import React from 'react';
import { isReplanApp } from '@utils/utils';
import { ReplanTextInactiveIcon } from '@icons/icons/ReplanTextInactiveIcon';
import { PlansimGreyLogoIcon } from '@icons/icons/PlansimGreyLogoIcon';

type Props = {
    active?: boolean;
};

const HeaderLogo = ({ active = false }: Props) => {
    const getLogoIconByOrigin = (url: string) => {
        if (isReplanApp(url)) {
            return <ReplanTextInactiveIcon />;
        }
        return <PlansimGreyLogoIcon />;
    };

    return <>{getLogoIconByOrigin(window.location.origin)}</>;
};

export default React.memo(HeaderLogo);
